import { createSelector } from '@reduxjs/toolkit';
import { MainState } from '../types';

const selectSelf = (state: MainState) => state.modal;

export const modalIdSelector = createSelector(selectSelf, (state) => state.modalId);

export const isModalOpenSelector = (modalId) =>
  createSelector(selectSelf, (state) => state.modalId === modalId);
